// Address form constants and options

export const countryOptions = [
  { value: 'US', label: 'United States' },
  { value: 'CA', label: 'Canada' },
  { value: 'MX', label: 'Mexico' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'FR', label: 'France' },
  { value: 'DE', label: 'Germany' },
  { value: 'IT', label: 'Italy' },
  { value: 'ES', label: 'Spain' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'BE', label: 'Belgium' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'AT', label: 'Austria' },
  { value: 'SE', label: 'Sweden' },
  { value: 'NO', label: 'Norway' },
  { value: 'DK', label: 'Denmark' },
  { value: 'FI', label: 'Finland' },
  { value: 'IE', label: 'Ireland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'GR', label: 'Greece' },
  { value: 'PL', label: 'Poland' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'HU', label: 'Hungary' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'HR', label: 'Croatia' },
  { value: 'RO', label: 'Romania' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LV', label: 'Latvia' },
  { value: 'EE', label: 'Estonia' },
  { value: 'JP', label: 'Japan' },
  { value: 'KR', label: 'South Korea' },
  { value: 'CN', label: 'China' },
  { value: 'AU', label: 'Australia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'SG', label: 'Singapore' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'IN', label: 'India' },
  { value: 'BR', label: 'Brazil' },
  { value: 'AR', label: 'Argentina' },
  { value: 'CL', label: 'Chile' },
  { value: 'CO', label: 'Colombia' },
  { value: 'PE', label: 'Peru' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'EG', label: 'Egypt' },
  { value: 'IL', label: 'Israel' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'RU', label: 'Russia' }
];

export const stateOptions = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' }
];

export const canadianProvinceOptions = [
  { value: 'AB', label: 'Alberta' },
  { value: 'BC', label: 'British Columbia' },
  { value: 'MB', label: 'Manitoba' },
  { value: 'NB', label: 'New Brunswick' },
  { value: 'NL', label: 'Newfoundland and Labrador' },
  { value: 'NS', label: 'Nova Scotia' },
  { value: 'ON', label: 'Ontario' },
  { value: 'PE', label: 'Prince Edward Island' },
  { value: 'QC', label: 'Quebec' },
  { value: 'SK', label: 'Saskatchewan' },
  { value: 'NT', label: 'Northwest Territories' },
  { value: 'NU', label: 'Nunavut' },
  { value: 'YT', label: 'Yukon' }
];

export const cruiseLineOptions = [
  { value: 'disney', label: 'Disney Cruise Line' },
  { value: 'royal-caribbean', label: 'Royal Caribbean' },
  { value: 'carnival', label: 'Carnival Cruise Line' },
  { value: 'norwegian', label: 'Norwegian Cruise Line' },
  { value: 'princess', label: 'Princess Cruises' },
  { value: 'celebrity', label: 'Celebrity Cruises' },
  { value: 'holland-america', label: 'Holland America Line' },
  { value: 'msc', label: 'MSC Cruises' },
  { value: 'costa', label: 'Costa Cruises' },
  { value: 'cunard', label: 'Cunard Line' },
  { value: 'virgin-voyages', label: 'Virgin Voyages' },
  { value: 'oceania', label: 'Oceania Cruises' },
  { value: 'regent', label: 'Regent Seven Seas' },
  { value: 'azamara', label: 'Azamara' },
  { value: 'silversea', label: 'Silversea' },
  { value: 'seabourn', label: 'Seabourn' }
];

export const shipOptions = {
  disney: [
    { value: 'disney-dream', label: 'Disney Dream' },
    { value: 'disney-fantasy', label: 'Disney Fantasy' },
    { value: 'disney-magic', label: 'Disney Magic' },
    { value: 'disney-wonder', label: 'Disney Wonder' },
    { value: 'disney-wish', label: 'Disney Wish' },
    { value: 'disney-treasure', label: 'Disney Treasure' }
  ],
  'royal-caribbean': [
    { value: 'symphony-of-the-seas', label: 'Symphony of the Seas' },
    { value: 'harmony-of-the-seas', label: 'Harmony of the Seas' },
    { value: 'allure-of-the-seas', label: 'Allure of the Seas' },
    { value: 'oasis-of-the-seas', label: 'Oasis of the Seas' },
    { value: 'voyager-of-the-seas', label: 'Voyager of the Seas' }
  ],
  carnival: [
    { value: 'carnival-vista', label: 'Carnival Vista' },
    { value: 'carnival-horizon', label: 'Carnival Horizon' },
    { value: 'carnival-panorama', label: 'Carnival Panorama' },
    { value: 'carnival-mardi-gras', label: 'Carnival Mardi Gras' }
  ],
  norwegian: [
    { value: 'norwegian-epic', label: 'Norwegian Epic' },
    { value: 'norwegian-breakaway', label: 'Norwegian Breakaway' },
    { value: 'norwegian-getaway', label: 'Norwegian Getaway' },
    { value: 'norwegian-escape', label: 'Norwegian Escape' }
  ]
};

// Helper functions for address handling
export const getStateProvinceOptions = (country) => {
  switch (country) {
    case 'US':
      return { options: stateOptions, label: 'State', placeholder: 'Select state' };
    case 'CA':
      return { options: canadianProvinceOptions, label: 'Province', placeholder: 'Select province' };
    default:
      return { options: [], label: 'State/Province', placeholder: 'Enter state/province' };
  }
};

export const getPostalCodeInfo = (country) => {
  switch (country) {
    case 'US':
      return { label: 'Zip Code', placeholder: 'Input zip code' };
    case 'CA':
      return { label: 'Postal Code', placeholder: 'Input postal code (e.g., K1A 0A9)' };
    case 'GB':
      return { label: 'Postcode', placeholder: 'Input postcode (e.g., SW1A 1AA)' };
    default:
      return { label: 'Postal Code', placeholder: 'Input postal code' };
  }
};

export const hasStructuredStates = (country) => {
  return ['US', 'CA'].includes(country);
};